function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rar_svg__clip0)",
  fill: "#0785FE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.938 13.594V1.405c0-.259.21-.469.468-.469h7.032v1.875c0 .518.42.938.937.938h1.875v1.406h.938V3.281a.469.469 0 00-.136-.333L9.239.136A.469.469 0 008.906 0h-7.5C.63 0 0 .63 0 1.406v12.188C0 14.37.63 15 1.406 15h3.282v-.938H1.405a.469.469 0 01-.468-.468z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.844 7.5H7.969a.938.938 0 00-.938.938v3.75h.938V10.78h1.875v1.406h.937v-3.75a.937.937 0 00-.937-.937zm0 2.344H7.969V8.438h1.875v1.406zM5.625 7.5H3.281a.469.469 0 00-.469.469v4.218h.938v-1.874h.277l1.739 1.739.66-.661-1.078-1.079h.277c.518 0 .938-.42.938-.937v-.938a.938.938 0 00-.938-.937zm0 1.875H3.75v-.938h1.875v.938zM15 9.375v-.938a.937.937 0 00-.938-.937H11.72a.469.469 0 00-.469.469v4.218h.938v-1.874h.276l1.74 1.739.66-.661-1.078-1.079h.277c.517 0 .937-.42.937-.937zm-2.813 0v-.938h1.876v.938h-1.876z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rar_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgRar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgRar;